var map = {
	"./01_dutch-oven.png": 8573,
	"./02_food-processor.jpg": 1858,
	"./03_baking-sheet.jpg": 4727,
	"./04_spray-bottle.jpg": 1026,
	"./05_pastry-brush.jpg": 358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3974;